import { CSSProperties } from "react";
import { VariableTokenSegment } from "./VariableTokenUtils";

interface VariableTextOverlayProps {
  segments: VariableTokenSegment[];
  containerClassName: string;
  contentClassName: string;
  textClassName: string;
  knownTokenClassName: string;
  unknownTokenClassName: string;
  scrollTop?: number;
  scrollLeft?: number;
  /** Width of the paired textarea's scrollbar; the content gives it up so both wrap alike. */
  scrollbarWidth?: number;
  contentStyle?: CSSProperties;
}

export default function VariableTextOverlay({
  segments,
  containerClassName,
  contentClassName,
  textClassName,
  knownTokenClassName,
  unknownTokenClassName,
  scrollTop = 0,
  scrollLeft = 0,
  scrollbarWidth = 0,
  contentStyle,
}: VariableTextOverlayProps) {
  return (
    <div aria-hidden className={containerClassName}>
      <div
        className={contentClassName}
        style={{
          transform: `translate(${-scrollLeft}px, ${-scrollTop}px)`,
          marginRight: scrollbarWidth || undefined,
          ...contentStyle,
        }}
      >
        {segments.map((segment, index) => {
          if (segment.type === "text") {
            return (
              <span key={`text-${index}`} className={textClassName}>
                {segment.text}
              </span>
            );
          }

          return (
            <span
              key={`token-${index}`}
              className={
                segment.isKnown ? knownTokenClassName : unknownTokenClassName
              }
            >
              {segment.text}
            </span>
          );
        })}
      </div>
    </div>
  );
}
